export default {
  navigationBarTitleText: '邀请好友返现金'
};
